import { render, staticRenderFns } from "./VlanComponent.vue?vue&type=template&id=01d28746&scoped=true&"
import script from "./VlanComponent.vue?vue&type=script&lang=js&"
export * from "./VlanComponent.vue?vue&type=script&lang=js&"
import style0 from "./VlanComponent.vue?vue&type=style&index=0&id=01d28746&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d28746",
  null
  
)

export default component.exports